import { Loader } from "@/components/Loader/Loader.tsx";
import { OverlayLoaderProps } from "@/components/Loader/OverlayLoader/OverlayLoaderProps.ts";
import { useTranslation } from "react-i18next";

export const OverlayLoader = (props: OverlayLoaderProps) => {
  const loading = props.loading;
  return (
    <>
      {loading && (
        <div className={`overlayLoader ${props.className}`}>
          <Loader loading={loading} small />
          <span className="overlayLoaderText">{props.text}</span>
        </div>
      )}
      <div style={{ opacity: loading ? 0.75 : 1 }}>{props.children}</div>
    </>
  );
};

export const PageOverlayLoader = (props: OverlayLoaderProps) => {
  const { t } = useTranslation();
  const loading = props.loading;

  return (
    <>
      {loading && (
        <div className={`pageOverlayLoader ${props.className}`}>
          <Loader loading={loading} />
          <span className="pageOverlayLoaderText">{props.text || t("loading")}</span>
        </div>
      )}
      <div className={`page-content ${loading ? "page-content--loading" : "page-content--loaded"}`}>
        {props.children}
      </div>
    </>
  );
};
